export default "__VITE_ASSET__B48zLmvu__"